import { render, staticRenderFns } from "./gallery-categorys.vue?vue&type=template&id=0069ac3e&"
import script from "./gallery-categorys.vue?vue&type=script&lang=ts&"
export * from "./gallery-categorys.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports